import React from 'react';
import { Ad } from 'ctm-components';

const FooterAd = (props) => {
    /**
     * Returns the Footer Ad Component
     * @returns {Node} Footer Ad Component
     */
    return  <Ad className="ad-main-bottom" id="ad-main-bottom" />;
};

export { FooterAd };
